import { MED_DESKTOP_WIDTH } from '../constants'

export const getScreenSize = () => {
  return window.innerWidth < MED_DESKTOP_WIDTH ? 'mobile' : 'desktop'
}